import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";
import { orgSchema } from "../../common/orgSchema";

export const organizationsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getOrganizationMarketplaces",
    method: "get",
    path: "/organizations/:orgId/marketplaces",
    status: 200,
    response: z.object({
      default_marketplace: z.string(),
      markets: z.record(
        z.string(),
        z.object({ product_count: z.number().optional(), ad_count: z.number().optional() }),
      ),
    }),
  })
    .addEndpoint({
      alias: "getOrganizations",
      method: "get",
      path: "/organizations",
      parameters: [
        {
          name: "org_type",
          type: "Query",
          schema: z.string().optional(),
        },
      ],
      status: 200,
      response: z.array(orgSchema),
    })
    .addEndpoint({
      alias: "putOrgId",
      method: "put",
      path: "/organizations/",
      parameters: [{ name: "body", type: "Body", schema: z.object({ id: z.number() }) }],
      status: 200,
      response: z.unknown(),
    })
    .build(),
);
